import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/services/api/WRCService'
import router from './router'
import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loggingIn: false,
    fullPage: true,
    user: {},
    accessToken: localStorage.getItem('access_token') || '',
    refreshToken: localStorage.getItem('refresh_token') || ''
  },
  mutations: {
    setFullPage(state, fullPage) {
      state.fullPage = fullPage
    },
    setTokens(state, tokens) {
      state.accessToken = tokens.accessToken
      state.refreshToken = tokens.refreshToken
    },
    setLoggingIn(state, loggingIn) {
      state.loggingIn = loggingIn
    },
    setUser(state, user) {
      state.user = user
    },
    logout(state) {
      state.accessToken = ''
      state.refreshToken = ''
    }
  },
  getters: {
    loggedIn: state => !!state.accessToken
  },
  actions: {
    login ({commit, dispatch}, credentials) {
      commit('setLoggingIn', true)

      api.login(credentials.username, credentials.password).then(({ data }) => {
        let accessToken = data.access_token
        let refreshToken = data.refresh_token

        let tokens = {
          accessToken: accessToken,
          refreshToken: refreshToken
        }

        axios.defaults.headers.common['Authorization'] = "bearer " + accessToken

        commit('setTokens', tokens)
        localStorage.setItem("access_token", tokens.accessToken);
        localStorage.setItem("refresh_token", tokens.refreshToken);

        dispatch('getProfile')

        router.push('/')

      }).catch((error) => {
        console.log('server error!!');
      }).then(() => {
        commit('setLoggingIn', false)
      });
    },
    logout ({commit}) {
      return new Promise((resolve, reject) => {
        commit('logout')
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        delete axios.defaults.headers.common['Authorization']

        setTimeout(function () {
          router.push('/login')
        })

        resolve()
      })
    },
    getProfile ({commit, getters}) {
      if (getters.loggedIn) {
        api.getProfile().then(({data}) => {
          commit('setUser', data.data)
        })
      }
    }
  }
})
